import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import db from "../firebase/fireInit";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import RatingBar from "../misc/elements/RatingBar";
import MainStore from "../stores/MainStore";
import InnerBoxLayout from "./InnerBoxLayout";

const GeneralBox = ({ general, preferedImage, objects }) => {
  const { getBoxType } = useHandleBoxTypes();
  const [bType, setBType] = useState(null);
  const { player } = MainStore();

  useEffect(() => {
    if (general) {
      const foundBoxType = getBoxType(general?.type);
      setBType(foundBoxType);
    }
  }, [general]);

  return (
    <InnerBoxLayout
      objects={objects}
      mainImage={preferedImage ?? `/icons/icon_${general?.type}.png`}
      leftImage={bType ? bType.ratings.general.first.general.icon : null}
      leftRating={general?.ratings.general.first}
      rightImage={bType ? bType.ratings.general.second.general.icon : null}
      rightRating={general?.ratings.general.second}
      upperBarText={general?.categories.slice(0, 2).join(" ")}
      type={general?.type}
      object={general}
      description={general?.shortDescription}
      boxType={bType}
    />
  );
};

export default GeneralBox;
